import { Component, EventEmitter, Input, Output } from '@angular/core';

interface NavItem {
  id: string;
  label: string;
  icon?: string;
}

@Component({
  selector: 'svc-settings-nav',
  templateUrl: './settings-nav.component.html',
  styleUrls: ['./settings-nav.component.scss'],
})
export class SettingsNavComponent {
  @Input() activeSection = 'service-mapping';
  @Output() sectionChange = new EventEmitter<string>();

  navItems: NavItem[] = [
    { id: 'service-mapping', label: 'Service Mapping', icon: 'build' },
    { id: 'dealer-recommendations', label: 'Dealer Recommendations', icon: 'event_repeat' },
    // Add items to populate side nav as needed, ensuring the id matches the section it corresponds to in the settings component
    // { id: 'settings', label: 'Settings', icon: 'settings' },
  ];

  select(id: string) {
    this.sectionChange.emit(id);
  }
}
